import { render } from "./userVideoMock.vue?vue&type=template&id=6f629bf2&scoped=true&lang=pug"
import script from "./userVideoMock.vue?vue&type=script&lang=js"
export * from "./userVideoMock.vue?vue&type=script&lang=js"

import "./userVideoMock.vue?vue&type=style&index=0&id=6f629bf2&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f629bf2"]])

export default __exports__